// extracted by mini-css-extract-plugin
export default {"flex":"part3_flex__3sH+N"};